/**
 * /seo-audit/report/$id — permanent, shareable URL for a stored audit report.
 * Re-renders from the stored results WITHOUT consuming a scan. Public (no
 * auth). noindex so report pages are never indexed.
 *
 * Phase 3: renders the free (general-tier) report with the same branded
 * styling as the results screen. Comprehensive reports render here too in
 * later phases.
 */
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import { AuditReportView } from "@/components/audit/AuditReportView";

export const Route = createFileRoute("/seo-audit/report/$id")({
  head: () => ({
    meta: [
      { title: "SEO Audit Report — The Outpost" },
      { name: "description", content: "Your stored SEO audit report." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ReportRoute,
});

function ReportRoute() {
  const { id } = Route.useParams();
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <AuditReportView id={id} />
      </Suspense>
    </PageTransition>
  );
}
